import { useState, useEffect } from 'react';
import { navLinks, siteConfig } from '@/mocks/homeData';

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="px-4 md:px-6">
        <div className="flex items-center justify-between h-[72px] max-w-[1400px] mx-auto">
          <a
            href="#hero"
            onClick={(e) => handleNavClick(e, '#hero')}
            className="flex items-center gap-2 no-underline cursor-pointer"
          >
            <span className="font-heading text-2xl font-black text-primary-500 tracking-tight">
              {siteConfig.name}
            </span>
          </a>

          <nav className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => handleNavClick(e, link.href)}
                className="text-sm font-medium text-foreground-700 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                {link.label}
              </a>
            ))}
          </nav>

          <div className="hidden md:flex items-center gap-3">
            <a
              href="#contact"
              onClick={(e) => handleNavClick(e, '#contact')}
              className="text-sm font-medium text-primary-500 border border-primary-300 hover:bg-primary-50 px-4 py-2 rounded-md transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              投稿爆料
            </a>
            <a
              href="#app"
              onClick={(e) => handleNavClick(e, '#app')}
              className="text-sm font-medium bg-primary-500 text-background-50 hover:bg-primary-600 px-4 py-2 rounded-md transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              吃瓜小程序
            </a>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-700 cursor-pointer"
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <nav className="flex flex-col px-4 py-4 gap-3">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => handleNavClick(e, link.href)}
                className="text-base font-medium text-foreground-700 hover:text-primary-500 transition-colors duration-200 py-2 cursor-pointer"
              >
                {link.label}
              </a>
            ))}
            <div className="flex gap-3 pt-3 border-t border-background-200/70">
              <a
                href="#contact"
                onClick={(e) => handleNavClick(e, '#contact')}
                className="flex-1 text-center text-sm font-medium text-primary-500 border border-primary-300 rounded-md py-2 cursor-pointer"
              >
                投稿爆料
              </a>
              <a
                href="#app"
                onClick={(e) => handleNavClick(e, '#app')}
                className="flex-1 text-center text-sm font-medium bg-primary-500 text-background-50 rounded-md py-2 cursor-pointer"
              >
                吃瓜小程序
              </a>
            </div>
          </nav>
        </div>
      )}
    </header>
  );
}